import React from 'react';
import pubsub from "@viewlift/pubsub";
import { useNavigate } from "react-router-dom";
import { arrowRight } from "../../../../images/icon";
import { iconsToShow } from "../navigation/iconsToShow";
import { handleNewTabLoader, handleStatusGaCalls } from '../../../helpers';
function index(props) {
    var navigate = useNavigate();
    var getIcon = function (item) {
        if ((item.icon).toLowerCase().includes("http://") || (item.icon).toLowerCase().includes("https://")) {
            return (React.createElement("img", { className: "dropdown-icon-main", src: item.icon, alt: item.title }));
        }
        else if ((item.icon).toLowerCase().includes("icon-")) {
            return (React.createElement("span", { className: "menu-icons" }, iconsToShow(item, (window.location.pathname === item.url), item.url)));
        }
        return '';
    };
    var handleKeyDown = function (e, item) {
        var _a, _b;
        // “activate” on Enter or Space
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            pubsub.publish('apploading', true);
            handleStatusGaCalls({ eventName: 'top_navigation', subSection: null, type: 'navigation', reason: (_a = props === null || props === void 0 ? void 0 : props.nav) === null || _a === void 0 ? void 0 : _a.title, status: item === null || item === void 0 ? void 0 : item.title, action: 'Click', paymentStatus: null, eventCategory: 'Navigation', additionalLabel: (_b = props === null || props === void 0 ? void 0 : props.nav) === null || _b === void 0 ? void 0 : _b.url, section: 'Navigation' });
            if (item === null || item === void 0 ? void 0 : item.newTab) {
                window.open(item.url);
                handleNewTabLoader();
            }
            else {
                navigate(item === null || item === void 0 ? void 0 : item.url);
            }
        }
    };
    return (React.createElement(React.Fragment, null, props.nav.items.length > 0 ? props.nav.items.map(function (item) {
        return React.createElement("div", { onClick: function () {
                var _a, _b;
                pubsub.publish('apploading', true);
                handleStatusGaCalls({ eventName: 'top_navigation', subSection: null, type: 'navigation', reason: (_a = props === null || props === void 0 ? void 0 : props.nav) === null || _a === void 0 ? void 0 : _a.title, status: item === null || item === void 0 ? void 0 : item.title, action: 'Click', paymentStatus: null, eventCategory: 'Navigation', additionalLabel: (_b = props === null || props === void 0 ? void 0 : props.nav) === null || _b === void 0 ? void 0 : _b.url, section: 'Navigation' });
                if (item === null || item === void 0 ? void 0 : item.newTab) {
                    window.open(item.url);
                    handleNewTabLoader();
                }
                else {
                    navigate(item === null || item === void 0 ? void 0 : item.url);
                }
            }, onKeyDown: function (e) { return handleKeyDown(e, item); }, key: item.pageId },
            React.createElement("div", { tabIndex: 0, className: "navigation-link-dropDown" },
                React.createElement("div", { className: "navigation-link-dropDown-head" },
                    (item === null || item === void 0 ? void 0 : item.icon) ? getIcon(item) : React.createElement(React.Fragment, null),
                    React.createElement("div", { className: "dropdown-title site-color" }, item.title)),
                props.isMobile ? React.createElement("div", { className: "navigation-link-icon" }, arrowRight()) : React.createElement(React.Fragment, null)));
    })
        :
            React.createElement(React.Fragment, null)));
}
export default index;
